
export default {
  name: 'DdtLayout',
  data () {
    return {
      isLoading: true
      // showTally: false
    }
  },
  computed: {
    departement () {
      if (this.$route.params.departement) {
        return this.$route.params.departement
      }
      if (this.$route.params.githubRef) {
        const [scope, ref] = this.$route.params.githubRef.split('-')

        if (ref && scope === 'dept') {
          return ref.padStart(2, '0')
        }
      }

      return this.$user.profile.departement
    },
    isVerified () {
      return this.$user?.profile?.verified || this.$user.profile.is_admin
    },
    trameRef () {
      if (this.$user.canViewSectionTramesPAC()) {
        const scopes = { ddt: 'dept', dreal: 'region' }
        const poste = this.$user.profile.poste
        const code = poste === 'ddt' ? this.departement : this.$user.profile.region

        return `${scopes[poste]}-${this.$options.filters.deptToRef(code)}`
      }
      return ''
    }
  },
  async mounted () {
    await this.$user.isReady
    this.isLoading = false

    if (!this.$user.canViewDDTLayout()) {
      console.warn('Page réservée aux sides État ou PPA.')
      this.$nuxt.context.redirect(302, '/')
    }

    // const displayedKey = 'tally-displayed-m6kNJP'
    // const formNb = window.localStorage.getItem(displayedKey) || 0
    // if (formNb < 1) {
    //   this.showTally = true
    //   window.Tally.loadEmbeds()
    //   localStorage.setItem(displayedKey, +formNb + 1)
    // }

    if (this.$route.query.contact) {
      this.$nuxtApi.post('/api/pipedrive/contacted', {
        email: this.$route.query.contact
      })
    }
  }
}
